import React, { useState } from 'react';
import { fc, calcPayoff } from '../../utils';

export function DebtPayoffCard({ state, r, totBal }) {
  const [extra, setExtra] = useState(0);

  if (!totBal || !r.mos) return null;

  const sim = extra > 0
    ? calcPayoff(state.cards || [], (state.extra || 0) + extra, state.method || 'avalanche', state.lump || 0)
    : null;

  const mosSaved = sim ? Math.max(0, r.mos - sim.mos) : 0;
  const intSaved = sim ? Math.max(0, r.int - sim.int) : 0;

  return (
    <div className="card cp" style={{ marginBottom: 12 }}>
      <div className="st">🎯 Debt Payoff Simulator</div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 12 }}>
        <span style={{ fontSize: 12, color: 'var(--mut)' }}>
          Current payoff: <strong style={{ color: 'var(--txt)' }}>{r.mos} months</strong>
        </span>
        <span style={{ fontSize: 12, color: 'var(--mut)' }}>
          Interest: <strong style={{ color: 'var(--red)' }}>{fc(r.int)}</strong>
        </span>
      </div>
      <div style={{ marginBottom: 14 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 6 }}>
          <span style={{ color: 'var(--mut)' }}>Extra per month</span>
          <span style={{ fontWeight: 800, color: 'var(--ylw)', fontSize: 15 }}>
            {extra > 0 ? '+' + fc(extra) : '$0'}
          </span>
        </div>
        <input
          type="range"
          min={0}
          max={500}
          step={10}
          value={extra}
          onChange={(e) => setExtra(Number(e.target.value))}
          style={{ width: '100%', accentColor: 'var(--ylw)', cursor: 'pointer' }}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 9, color: 'var(--mut)', marginTop: 2 }}>
          <span>$0</span><span>+$500/mo</span>
        </div>
      </div>
      {extra > 0 && sim ? (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
          <div style={{ padding: '10px 12px', background: 'rgba(107,203,119,.08)', border: '1px solid rgba(107,203,119,.2)', borderRadius: 10, textAlign: 'center' }}>
            <div style={{ fontSize: 24, fontWeight: 900, color: 'var(--grn)', lineHeight: 1 }}>{mosSaved}</div>
            <div style={{ fontSize: 10, color: 'var(--mut)', marginTop: 3 }}>months sooner</div>
          </div>
          <div style={{ padding: '10px 12px', background: 'rgba(107,203,119,.08)', border: '1px solid rgba(107,203,119,.2)', borderRadius: 10, textAlign: 'center' }}>
            <div style={{ fontSize: 20, fontWeight: 900, color: 'var(--grn)', lineHeight: 1 }}>{fc(intSaved)}</div>
            <div style={{ fontSize: 10, color: 'var(--mut)', marginTop: 3 }}>interest saved</div>
          </div>
        </div>
      ) : (
        <div style={{ padding: '10px', background: 'var(--surf2)', borderRadius: 8, textAlign: 'center', fontSize: 11, color: 'var(--mut)' }}>
          Move the slider to see your savings
        </div>
      )}
    </div>
  );
}
